import { Component } from "@angular/core";
import {
  LoadingController,
  ModalController,
  NavParams,
  ViewController,
} from "ionic-angular";
import { BasePage } from "../../../pages/base-page";
import { CalendarService } from "../../../providers/calendar-service/calendar-service";
import { NavBarServiceProvider } from "../../../providers/nav-bar-service/nav-bar-service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { NavigationService } from "../../navigation.service";

@Component({
  selector: "calendar-notifications-popover",
  templateUrl: "calendar-notifications-popover.html",
})
export class CalendarNotificationsPopoverPage extends BasePage {
  applications: Array<{ id: string; icon: string; url: string }> = [];
  patientChartId: number;
  calendarNotifications: Array<object>;
  spinner = null;
  spinnerCounter = 0;
  public acceptTaskView: object = {};
  calendarActiveStatus: any;
  calendarLink: any;
  notificationCount: number = 0;

  constructor(
    public loadingCtrl: LoadingController,
    public calendarService: CalendarService,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public navSvc: NavigationService,
    public stateData: StateManagementService,
    private navBarService: NavBarServiceProvider
  ) {
    super(stateData);
    this.applications = navParams.get("applications");
    this.patientChartId = navParams.get("patientChartId");
    this.calendarActiveStatus = window.localStorage["calendarStatus"];
    this.calendarLink = "Calendar View";
  }
  close() {
    this.viewCtrl.dismiss();
  }

  viewDetails(notification) {
    // let extendedProps = notification.extendedProperties ? notification.extendedProperties.private : {}
    // this.acceptTaskView["text"] = notification.text;
    // this.acceptTaskView["eventId"] = notification.id;
    // this.acceptTaskView["assignedTo"] = extendedProps.assignTo;
    // this.acceptTaskView["patientName"] = extendedProps.patient;
    // this.acceptTaskView["status"] = "confirmed";
    // this.acceptTaskView["age"] = '89 (04/28/1925)';
    // this.acceptTaskView["levelOfCare"] = 'TBD';
    // this.acceptTaskView["team"] = extendedProps.careTeam;
    // this.acceptTaskView["diagnosis"] = "Alzheimer’s Disease"
    // let acceptViewModal = this.modalCtrl.create('CalendarAcceptTaskPage', {
    //     acceptTaskView: this.acceptTaskView,
    // }, { enableBackdropDismiss: false, cssClass: 'accept-decline-popover' });
    // acceptViewModal.onDidDismiss(data => {
    //     this.viewCtrl.dismiss();
    //     if (!(data.cancel)) {
    //         this.notificationCount -= 1
    //         // this.calendarService.publish(this.isNewCal);
    //     }
    // });
    // acceptViewModal.present();
  }

  launchApp(url: string) {
    window.location.replace(url);
  }

  sendToCalendarDashboard(patientChartId) {
    let id: string = "NewCalendarPage";
    if (isNaN(patientChartId)) {
      patientChartId = 0;
      this.navSvc.goToInternalPage(id, { patChartId: patientChartId });
    } else {
      this.navSvc.goToInternalPage(id, { patChartId: patientChartId });
    }
    this.viewCtrl.dismiss();
  }
  increaseSpinnerCount(message: string = "Creating Assessment...") {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  decreaseSpinnerCount() {
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }
  deny(notification) {
    // let eventData = {
    //     "id": notification.id,
    //     "responseStatus": "declined"
    // };
    // this.calendarService.acceptDenyEvent(eventData).subscribe(
    //     returnData => {
    //         if (!returnData) {
    //             return;
    //         } else {
    //             this.updateNotificationData(notification);
    //         }
    //     })
  }
  accept(notification) {
    // let eventData = {
    //     "id": notification.id,
    //     "responseStatus": "accepted"
    // };
    // this.calendarService.acceptDenyEvent(eventData).subscribe(
    //     returnData => {
    //         if (!returnData) {
    //             return;
    //         } else {
    //             this.updateNotificationData(notification);
    //         }
    //     })
  }
  loadNotificationData() {
    // this.increaseSpinnerCount("Loading...");
    // this.calendarService.getNeedActionEvents(window.localStorage.calendarID).subscribe(data => {
    //     let oldCalendarData = [];
    //     let newCalendarData = [];
    //     let eventsData = data;
    //
    //     for (let prop in eventsData) {
    //         let eventDataTemp = {
    //             "id": eventsData[prop].id,
    //             "text": eventsData[prop].summary,
    //             "start_date": moment(eventsData[prop].startDateTime).format("YYYY-MM-DD HH:mm"),
    //             "end_date": moment(eventsData[prop].endDateTime).format("YYYY-MM-DD HH:mm"),
    //             "calendar_id": eventsData[prop].calenderId,
    //             "location": eventsData[prop].location,
    //             "attendees": eventsData[prop].attendees,
    //             "extendedProperties": eventsData[prop].extendedProperties
    //         };
    //
    //         // if (eventsData[prop].extendedProperties.private.isNewCalData === undefined) {
    //         //     oldCalendarData.push(eventDataTemp);
    //         // }
    //         newCalendarData.push(eventDataTemp);
    //     }
    //     if (this.isNewCal) {
    //         this.calendarNotifications = newCalendarData;
    //         this.notificationCount = newCalendarData.length;
    //     } else {
    //         this.calendarNotifications = oldCalendarData;
    //         this.notificationCount = oldCalendarData.length;
    //     }
    //
    //     let calendarNotificationsCount: any = this.notificationCount;
    //     this.calendarService._subject.next(calendarNotificationsCount);
    //     this.decreaseSpinnerCount();
    // },
    //     err => {
    //         this.decreaseSpinnerCount();
    //         console.error(err);
    //     });
  }

  updateNotificationData(notification) {
    this.calendarNotifications = this.calendarNotifications.filter(
      (item) => item["id"] !== notification["id"]
    );
    this.notificationCount = this.calendarNotifications.length;
    // this.calendarService.publish(this.isNewCal);
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/calendar-notifications-popover/calendar-notifications-popover.ts